import * as React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { history } from '../redux/store';
import { ExternalRoutes, InternalRoutes } from "./index";
import InternalLayout from '../components/ReusableComponents/Layouts/InternalLayout';
import ExternalLayout from '../components/ReusableComponents/Layouts/ExternalLayout';
import { push } from 'connected-react-router';
import { connect } from "react-redux";
import PrivateRoute from './PrivateRoute';
import { RouteProps } from 'react-router';
import Page404 from '../Pages/Page404';
import { IStore, ICompanyData } from '../redux/constants';
import Lazy from "../components/Lazy"
import { Suspense } from 'react';
import SignIn from '../Pages/SignIn';
import { GetCompanyDataResult } from '../Interfaces/Interfaces';
import { checkIfRevoultPaymentAllowed } from '../Helpers/DataHelpers';

const mapStateToProps = (state: IStore) => ({
    userData: state.auth.UserData,
    isAuth: state.auth.isAuth,
    isTokenExpired: state.auth.isTokenExpired,
    isTokenValid: state.auth.isTokenValid,
    location: state.router.location,
    CompanyData: state.auth.CompanyData,
    ConfigCompanyData: state.CompanyData,
});
export interface AppProps {
    userData?: any;
    history: any;
    location: any;
    routes?: any;
    isAuth: boolean;
    isTokenExpired: boolean;
    isTokenValid: boolean;
    CompanyData: ICompanyData;
    ConfigCompanyData: GetCompanyDataResult;
}
export interface AppState {
}
interface Props2 extends RouteProps {
    component: new (props: any) => React.Component | any;
    userData: any;
    layoutComp: any;
    path: any;
    closedMenu: any;
    subtab: any;
}

const MapPrivateRoutes = (routes: any) =>
    routes.map(({ path, component: Component }: Props2, index: any) =>
        <PrivateRoute
            key={index}
            path={path}
            exact
            isAuth={true}
            component={
                (props: any) => (
                    <InternalLayout >
                        <Suspense fallback={<Lazy />}>
                            <Component {...props} />
                        </Suspense>
                    </InternalLayout >
                )
            }
        />
    );

const MapExternalRoutes = (routes: any) =>
    routes.map(({ path, component: Component2, layoutComp: any }: Props2, index: any) =>
        <Route
            key={index}
            path={path}
            exact
            render={props => (
                <ExternalLayout>
                    <Component2 {...props} />
                </ExternalLayout>
            )}
        />
    );

class Routes extends React.Component<AppProps, AppState> {
    render() {
        let _isServiceTicket = this.props.location && this.props.location.pathname && this.props.location.pathname.toLowerCase() === "/servicedesk/ticket";
        const isAllowedPayment = checkIfRevoultPaymentAllowed({ ConfigCompanyData: this.props.ConfigCompanyData, CompanyData: this.props.CompanyData })
        return (
            <React.Suspense fallback>
                <Router history={history}>
                    <React.Fragment>
                        <Switch>
                            {MapExternalRoutes(ExternalRoutes)}
                            {MapPrivateRoutes(InternalRoutes(this.props.userData.isAdmin, this.props.isAuth, isAllowedPayment))}
                            {!this.props.isAuth && _isServiceTicket && <Route
                                render={props => (
                                    <Suspense fallback={<Lazy />}>
                                        <ExternalLayout>
                                            <SignIn
                                                {...props}
                                                isServiceTicket={true}
                                                ServiceTicketURL={window.location.href}
                                            />
                                        </ExternalLayout>
                                    </Suspense>
                                )} />}
                            {this.props.isAuth &&
                                <Route
                                    render={() => (
                                        <Suspense fallback={<Lazy />}>
                                            <Page404
                                                path={this.props.location && this.props.location ? this.props.location.pathname : null}
                                                isAdmin={this.props.userData.isAdmin}
                                                isAuth={this.props.isAuth /*&& this.props.isTokenValid && !this.props.isTokenExpired*/}
                                            />
                                        </Suspense>
                                    )} />}
                            {!this.props.isAuth &&
                                <Route
                                    render={() => (
                                        <Page404
                                            path={this.props.location && this.props.location ? this.props.location.pathname : null}
                                            isAdmin={this.props.userData.isAdmin}
                                            isAuth={this.props.isAuth && this.props.isTokenValid && !this.props.isTokenExpired}
                                        />)} />}
                        </Switch>
                    </React.Fragment>
                </Router>
            </React.Suspense >
        );
    }
}
export default connect(mapStateToProps, { push })(Routes);
